export default "__VITE_ASSET__cfa63f52__"